<template>
    <div>
        <h2>Unit Metrics</h2>
        <v-card>
            <v-container fluid v-if="unit.latestMetrics">
                <v-layout row wrap>
                    <v-flex md6>
                        Metrics from {{unit.latestMetrics | formatDate}} ({{fromNow}})
                    </v-flex>
                    <v-chip v-if="unit.hasFailedMetrics" class="red lighten-1 white--text">Failed Metrics</v-chip>
                    <v-spacer/>
                    <v-chip v-if="unit.isLowUse" class="purple lighten-2 white--text">Low Use Unit</v-chip>
                    <v-spacer/>
                    <v-btn align="right" @click="openUnitMetrics()">Metrics</v-btn>

                    <v-dialog v-model="dialog" max-width="800px">
                        <UnitMetricsList
                            v-model="model"
                            ref="unitMetricsForm"
                            @close="dialog = false"
                        >
                            <template v-slot:header>
                                <v-spacer></v-spacer>
                                <v-btn @click="dialog=false" icon text>
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                        </UnitMetricsList>
                    </v-dialog>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md6>
                        <v-text-field v-model="unit.endingHours" label="End Hours" disabled></v-text-field>
                    </v-flex>
                    <v-flex md6>
                        <v-text-field
                            v-model="unit.averageHours"
                            label="Average Hours (per calendar day)"
                            disabled
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md6>
                        <v-text-field
                            v-model="unit.endingKilometres"
                            label="End Kilometres"
                            disabled
                        ></v-text-field>
                    </v-flex>
                    <v-flex md6>
                        <v-text-field
                            v-model="unit.averageKilometres"
                            label="Average Kilometres (per calendar day)"
                            disabled
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container fluid v-else>
                <v-layout row wrap>
                    <v-flex>No metrics found</v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </div>
</template>
<script>
  import UnitMetricsList from '@/components/Units/Details/UnitMetrics/UnitMetricsList.vue';
  import moment from 'moment';

  export default {
    props: {unit: {required: true}},
    components: {
      UnitMetricsList
    },
    data() {
      return {
        dialog: false,
        model: {}
      };
    },
    methods: {
      openUnitMetrics() {
        this.model = {
          unitId: this.unit.id,
          unitName: this.unit.number,
        };
        this.dialog = true;

        if (this.$refs.unitMetricsForm) {
          this.$refs.unitMetricsForm.init();
        } else {
          setTimeout(() => this.$refs.unitMetricsForm.init(), 10);
        }
      },
    },
    computed: {
      fromNow() {
        return moment(this.unit.latestMetrics).from(moment().startOf('day'));
      }
    }
  };
</script>
